import { CouponCodeViewEnum } from "./enum";
import { Copies } from "shared/hooks/useCopies";
import { getFormattedCurrency } from "shared/utils";
import ApiPurchaseOrderLine from "shared/model/ApiPurchaseOrderLine";
import RateCardDiscountType from "shared/enums/RateCardDiscountType";

export function getCouponCodeDiscountMessage(copies: Copies, purchaseOrderLine: ApiPurchaseOrderLine) {
  return purchaseOrderLine.discountForUser?.discountType === RateCardDiscountType.PERCENTAGE &&
    purchaseOrderLine.discountForUser?.percentage
    ? copies.get("coupon.code.at.checkout.discount.percent.message", {
        0: purchaseOrderLine.discountForUser?.percentage
      })
    : purchaseOrderLine.discountForUser?.discountType === RateCardDiscountType.FIXED_PRICE &&
      purchaseOrderLine.discountForUser?.fixedPriceDiscount
    ? copies.get("coupon.code.at.checkout.discount.fixed.price.message", {
        0: getFormattedCurrency(purchaseOrderLine.discountForUser?.fixedPriceDiscount)
      })
    : "";
}

export function getCouponCodeApplicableView(props: {
  showCouponCode?: boolean;
  disableCouponActions?: boolean;
  purchaseOrderLine: ApiPurchaseOrderLine;
}) {
  if (props.purchaseOrderLine?.couponCode) {
    return CouponCodeViewEnum.COUPON_APPLIED;
  } else if (props.showCouponCode && !props.purchaseOrderLine?.couponCode && !props.disableCouponActions) {
    return CouponCodeViewEnum.COUPON_APPLICABLE;
  } else if (props.showCouponCode && !props.disableCouponActions) {
    return CouponCodeViewEnum.COUPON_CODE_INPUT;
  } else {
    return CouponCodeViewEnum.NONE;
  }
}
